let baseURL;
baseURL = "https://qa-gateway-corporateportal.appinsnap.com/";

export { baseURL };
